export const RECOVERY_HOUR = 3600000
export type OfferEmailMessage = {from:string;to:string[];subject:string;html:string;text:string;replyTo:string}
export type OfferEmailDelivery = {step:number;at:string;providerId:string;email:OfferEmailMessage}
export type DesignRecovery = {
  id: string; baseCents: number; name: string; email: string;
  status: 'queued' | 'active' | 'stopped' | 'paid' | 'needs_review' | 'completed';
  consultationAfterDesign?: boolean;
  queuedAt: string; startedAt?: string; nextSendAt?: string; sent: number[];
  attempt?: { step: number; at: string; email?: OfferEmailMessage }; lastError?: string;
  deliveries?: OfferEmailDelivery[];
  checkout?: { key: string; createdAt: string; cents: number; grossCents: number; creditCents: number; expiresAt: number; sessionId?: string };
}
export function recoveryPrice(offer: Pick<DesignRecovery,'baseCents'|'startedAt'>, now = Date.now()) {
  const start = Date.parse(offer.startedAt || '');
  if (!Number.isSafeInteger(offer.baseCents) || offer.baseCents <= 0 || !Number.isFinite(start)) throw Error('This offer is not ready yet.');
  const first = start + 72 * RECOVERY_HOUR, last = start + 168 * RECOVERY_HOUR;
  const discount = now < first ? 50 : now < last ? 25 : 0;
  return { baseCents: offer.baseCents, amountCents: Math.round(offer.baseCents * (100-discount)/100), discount,
    firstEndsAt: new Date(first).toISOString(), finalEndsAt: new Date(last).toISOString(),
    nextDeadline: discount === 50 ? new Date(first).toISOString() : discount === 25 ? new Date(last).toISOString() : null };
}
